<mpb-navigation></mpb-navigation>
<mpb-featured-courses
  [featuredCourses]="homeCourses"
  [infoContent]="infoContent"
  [hideSeeMore]="hideSeeMoreBtn"
></mpb-featured-courses>
<mpb-footer></mpb-footer>
